import { Box, useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

interface ScrollbarProps {
  children?: ReactNode;
  style?: any;
  autoHide?: boolean;
}

const Scrollbar: FC<ScrollbarProps> = ({ children, autoHide, ...rest }) => {
  const theme = useTheme();

  return (
    <Scrollbars
      autoHide={autoHide}
      autoHideTimeout={1000}
      // autoHeight
      autoHeightMax={1000}
      renderThumbVertical={() => {
        return (
          <Box
            sx={{
              width: 5,
              background: `${theme.colors.neutral.black[20]}`,
              borderRadius: `${theme.general.borderRadiusLg}`,
              transition: `${theme.transitions.create(['background'])}`,

              '&:hover': {
                background: `${theme.colors.neutral.black[40]}`,
              },
            }}
          />
        );
      }}
      {...rest}
    >
      {children}
    </Scrollbars>
  );
};

export default Scrollbar;
